import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { LanguagePicker } from "../components/LanguagePicker";
import { api } from "../lib/api";

/** Errors the callback can hand back, each with something to do about it. */
const KNOWN_ERRORS = ["missing_state", "expired_state", "verification_failed"];

export function LoginPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const error = params.get("error");

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950 px-6">
      <div className="fixed right-6 top-6">
        <LanguagePicker />
      </div>

      <div className="w-full max-w-md">
        <h1 className="text-3xl font-semibold tracking-tight">LMU Stats</h1>
        <p className="mt-3 text-zinc-400">{t("login.tagline")}</p>

        {error && (
          <div className="mt-6 rounded-lg border border-red-900/60 bg-red-950/40 px-4 py-3 text-sm text-red-200">
            {t(
              KNOWN_ERRORS.includes(error)
                ? `login.errors.${error}`
                : "login.errors.generic",
            )}
          </div>
        )}

        <a
          href={api.steamLoginUrl("/")}
          className="mt-8 flex w-full items-center justify-center gap-3 rounded-lg bg-sky-500 px-4 py-3 font-medium text-zinc-950 transition-colors hover:bg-sky-400"
        >
          {t("login.steam")}
        </a>

        <p className="mt-6 text-xs leading-relaxed text-zinc-500">
          {t("login.privacy")}
        </p>
      </div>
    </div>
  );
}
